import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import { CyclicTabbingService as impl } from '@wix/viewer-service-cyclic-tabbing/implementations'
import type {
	ICyclicTabbingDefinition,
	ICyclicTabbingServiceConfig,
} from '@wix/viewer-service-cyclic-tabbing/definition'
import { CyclicTabbingDefinition as definition } from '@wix/viewer-service-cyclic-tabbing/definition'

export const cyclicTabbingService = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(siteFeatureConfig: ICyclicTabbingServiceConfig): ServiceProvider<ICyclicTabbingDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config: siteFeatureConfig,
		}
	}
)
